import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { Pagination } from "@/domain/entities/Pagination";
import {
  BulkBookingAddForm,
  BulkBookingEntities,
  BulkBookingResiEntities,
  BulkBookingSuccess,
  ClientBookingEntities,
  ClientBookingTemplateDetail,
  DetailRepairBulkBooking
} from "@/domain/entities/BulkBooking";
import {
  BulkBookingApiRequest,
  ClientBookingListParams
} from "@/data/payload/api/BulkBookingApiRequest";
import { container } from "tsyringe";
import { BulkBookingPresenter } from "../presenters/BulkBookingPresenter";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { BookingController } from "./BookingController";
import { AccountController } from "./AccountController";
import { PrintDataEntitas } from "@/domain/entities/Booking";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import {
  RequestBulkBooking,
  EditClientTemplateConfiguration,
  CreateClientTemplateConfiguration,
  DeleteSttRepair,
  RequestDetailRepairBulkBooking
} from "@/data/payload/api/BulkApiRequest";
import { BookingPresenter } from '../presenters/BookingPresenter';
import { AddBookingRequestInterface } from '@/data/payload/contracts/BookingRequest';
import { AddBookingCorporate } from '@/data/payload/api/BookingRequest';
import { TryCatch } from '@sentry/vue';
import { TrackingPresenter } from '../presenters/TrackingPresenter';

export interface BulkBookingState {
  isLoading: boolean;
  isError: boolean;
  errorCause: string;
  isModalSuccess: boolean;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "bulk-booking"
})
class BulkBookingStore extends VuexModule implements BulkBookingState {
  public IsOpenUploadBulkBooking = false;
  public isLoading = false;
  public IsOpenReUploadBulkBooking = false;
  public openModalSuccess = false;
  public clientName = "";
  public isError = false;
  public errorCause = "";
  public pagination = {
    page: 1,
    limit: 20
  };
  public bulkBookingList = new BulkBookingEntities(
    new Pagination(this.pagination.page, this.pagination.limit),
    []
  );
  public isConfirm = false;
  public errorDownload = false;
  public isFirstRequest = true;
  public resiListData: Array<PrintDataEntitas> = [];
  public status = "";
  public form = new BulkBookingAddForm();
  public isClearFile = false;
  public detailClientBookingData = new ClientBookingTemplateDetail();
  public detailRepairBulkBookingData = new DetailRepairBulkBooking();
  public clientBookingList = new ClientBookingEntities(
    new Pagination(this.pagination.page, this.pagination.limit),
    []
  );
  public isModalSuccess = false;
  public isErrorRepair = {
    senderPhone: false,
    senderAddress: false,
    senderName: false,
    receiverPhone: false,
    receiverAddress: false,
    receiverName: false,
    receiverAddressType: false,
    destinationDistrictName: false,
    destinationPostalCode: false,
    commodityCode: false,
    codAmount: false,
    externalNumber: false,
    insuranceFlag: false,
    manualSttNumber: false,
    originDistrictName: false,
    productType: false,
    serviceType: false,
    shipmentId: false,
    totalPieces: false,
    totalWeight: false,
    valueOfGoods: false,
    senderPhoneCaption: "",
    senderAddressCaption: "",
    senderNameCaption: "",
    receiverPhoneCaption: "",
    receiverAddressCaption: "",
    receiverNameCaption: "",
    receiverAddressTypeCaption: "",
    destinationDistrictNameCaption: "",
    destinationPostalCodeCaption: "",
    commodityCodeCaption: "",
    codAmountCaption: "",
    externalNumberCaption: "",
    insuranceFlagCaption: "",
    manualSttNumberCaption: "",
    originDistrictNameCaption: "",
    productTypeCaption: "",
    serviceTypeCaption: "",
    shipmentIdCaption: "",
    totalPiecesCaption: "",
    totalWeightCaption: "",
    valueOfGoodsCaption: ""
  };
  public lastRowNumber = 1;

  @Action
  getBulkBookingList(params: RequestBulkBooking) {
    this.setIsLoading(true);
    const presenter = container.resolve(BulkBookingPresenter);
    presenter
      .getListBulkBooking(params)
      .then((res: BulkBookingEntities) => {
        this.setBulkBookingData(res);
        this.setError(false);
        this.setErrorCause("");
      })
      .catch((error: any) => {
        this.setError(true);
        this.setErrorCause(error.response ? "server" : "internet");
      })
      .finally(() => this.setIsLoading(false));
  }

  @Action
  getListClientBooking(params: ClientBookingListParams) {
    this.setIsLoading(true);
    const presenter = container.resolve(BulkBookingPresenter);
    presenter
      .getListClientBookingTemplate(params)
      .then((res: ClientBookingEntities) => {
        this.setClientBookingData(res);
        this.setError(false);
        this.setErrorCause("");
      })
      .catch((error: any) => {
        this.setError(true);
        this.setErrorCause(error.response ? "server" : "internet");
      })
      .finally(() => this.setIsLoading(false));
  }

  @Action
  uploadBulkBooking(payload: {
    activityName: string;
    archiveFile: any;
    posClientId: number;
    posClientType: string;
    templateFormat: string;
    versionType: string;
  }) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(BulkBookingPresenter);
    return presenter
      .uploadBulkBooking(
        new BulkBookingApiRequest(
          payload.activityName,
          payload.archiveFile,
          payload.posClientId,
          payload.posClientType,
          payload.templateFormat,
          payload.versionType
        )
      )
      .then((res: ResponsePayload) => {
        return res;
      })
      .catch((error: any) => {
        if (payload.versionType === 'stt-v2' && error.code === "ERR_NETWORK") {
          MainAppController.showErrorMessage(
            parsingErrorResponse(error)
          );
        } else if (payload.versionType === 'stt-v2') {
          return error;
        } else {
          MainAppController.showErrorMessage(
            parsingErrorResponse(error, "Unggah Berkas Gagal !", () =>
              this.uploadBulkBooking(payload)
            )
          );
        }
        return new ResponsePayload();
      })
      .finally(() => {
        MainAppController.closeLoading();
        this.setStatusClearFile(true);
      });
  }

  @Action
  public async getBulkBookingResi(params: { id: number }) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(BulkBookingPresenter);
    return presenter
      .getListBulkBookingResi(params.id)
      .then(async (res: BulkBookingResiEntities) => {
        const list: Array<any> = [];
        let index = 0;
        for (const item of res.data) {
          const resi = await BookingController.generatePrintThermal({
            stt: item.sttId,
            accountType:
              AccountController.accountData.account_type === "partner"
                ? AccountController.accountData.account_type_detail.type
                : AccountController.accountData.account_type
          });

          list.push(resi);
          if (index === res.data.length - 1) {
            this.setResiListData(list);
          }

          index++;
        }

        return true;
      })
      .catch((error: any) => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Cetak Resi Gagal !", () =>
            this.getBulkBookingResi(params)
          )
        );
        return false;
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  @Action
  public fetchBulkBookingList(filter: {
    search: string;
    createdType: string;
    createdId: number;
    status: string;
    startDate?: string;
    endDate?: string;
    bookedType?: string;
    archiveType?: string;
  }) {
    this.setFirstRequest(false);
    this.getBulkBookingList(
      new RequestBulkBooking({
        archiveType: filter.archiveType ? filter.archiveType : "stt",
        page: this.bulkBookingList.pagination.page,
        limit: this.bulkBookingList.pagination.limit,
        search: filter.search,
        status: filter.status,
        createdType: filter.createdType,
        createdId: filter.createdId,
        isTotalData: true,
        startDate: filter.startDate,
        endDate: filter.endDate,
        bookedType: filter.bookedType
      })
    );
  }

  @Action
  public fetchClientBookingList(filter: { search: string }) {
    this.setFirstRequest(false);
    this.getListClientBooking(
      new ClientBookingListParams({
        page: this.clientBookingList.pagination.page,
        limit: this.clientBookingList.pagination.limit,
        search: filter.search,
        isTotalData: true
      })
    );
  }

  @Action
  public getSuccessListBooked(id: number) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(BulkBookingPresenter);
    return presenter
      .getSuccessListBooked(id)
      .then((res: BulkBookingSuccess) => res)
      .catch((error: any) => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Unduh Gagal !", () =>
            this.getSuccessListBooked(id)
          )
        );
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  @Action
  public getDetailClientBooking(id: number) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(BulkBookingPresenter);
    return presenter
      .getDetailClientBookingTemplate(id)
      .then((res: ClientBookingTemplateDetail) => {
        this.setDetailClientBooking(res);
      })
      .catch((error: any) => {
        this.setError(true);
        this.setErrorCause(error.response ? "server" : "internet");
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  @Action
  public downloadFailedFile(id: number) {
    const presenter = container.resolve(BulkBookingPresenter);
    presenter.downloadFailedFile(id, false);
  }

  @Action
  public selectStatus(value: string) {
    this.selectType(value);
  }

  @Action
  public editClientTemplateConfiguration(params: {
    id: number;
    headerMapping: any;
  }) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();

    const presenter = container.resolve(BulkBookingPresenter);
    const payload = new EditClientTemplateConfiguration(params.headerMapping);
    return presenter
      .editClientTemplateConfiguration(params.id, payload)
      .then(() => {
        this.setModalSuccess(true);
        return true;
      })
      .catch((err: any) => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(err, "Pembuatan Gagal !", () =>
            this.editClientTemplateConfiguration(params)
          )
        );
        this.setModalSuccess(false);
        return false;
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  @Action
  public createClientTemplateConfiguration(params: {
    accountRefId: number;
    accountRefType: string;
    headerMapping: any;
  }) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();

    const presenter = container.resolve(BulkBookingPresenter);
    const payload = new CreateClientTemplateConfiguration(
      params.accountRefId,
      params.accountRefType,
      params.headerMapping
    );
    return presenter
      .createClientTemplateConfiguration(payload)
      .then(() => {
        this.setModalSuccess(true);
        return true;
      })
      .catch((err: any) => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(err, "Pembuatan Gagal !", () =>
            this.createClientTemplateConfiguration(params)
          )
        );
        this.setModalSuccess(false);
        return false;
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  @Action
  public async repairBooking(
    params: {
      payload: AddBookingRequestInterface | AddBookingCorporate,
      formType: "client" | "manual"
    }
  ) {
    MainAppController.showLoading()
    const presenter = container.resolve(BookingPresenter);
      try {
        if (params.formType === "manual" || AccountController.accountData.isAllClient) {
          return await presenter.addManualBooking(params.payload);
        } else {
          return await presenter.addBookingCorporate(params.payload);
        }
      } catch (err) {
        MainAppController.showErrorMessage(parsingErrorResponse(err, "Booking gagal!"));
        throw err;
      } finally {
        MainAppController.closeLoading();
      }
  }

  @Action
  public deleteSttRepair(payload: DeleteSttRepair) {
    const presenter = container.resolve(BulkBookingPresenter);
    MainAppController.showLoading();
    return new Promise((resolve, reject) => {
      presenter.deleteSttRepair(payload)
        .then(() => {
          resolve(true)
        }).catch((err: any) => {
          const errorMessage = typeof err.message === "string" ? err.message : err;
          reject(err);
          MainAppController.showErrorMessage(
            parsingErrorResponse(errorMessage, "Perbaiki booking gagal dihapus!")
          )
        }).finally(() => {
          MainAppController.closeLoading();
        });
    })
  }

  @Action
  public getDetailRepairBulkBooking(params: RequestDetailRepairBulkBooking) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(BulkBookingPresenter);
    return presenter
      .getDetailRepairBulkBooking(params)
      .then((res: DetailRepairBulkBooking) => {
        BookingController.setModelValueFormGetDetailRepair(res);
        this.setDetailRepairBulkBooking(res);
        return res;
      })
      .catch((error: any) => {
        this.setError(true);
        this.setErrorCause(error.response ? "server" : "internet");
        throw error;
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  @Action
  public downloadSuccessBulkBooking(id: number) {
    const presenter = container.resolve(BulkBookingPresenter);
    presenter.downloadSuccessBulkBooking(id);
  }

  @Action
  public downloadFailedFileV2(id: number) {
    const presenter = container.resolve(BulkBookingPresenter);
    presenter.downloadFailedFile(id, true);
  }

  @Mutation
  public async selectType(value: string) {
    this.status = value;
  }

  @Mutation
  public setErrorDownload(val: boolean) {
    this.errorDownload = val;
  }

  @Mutation
  private setBulkBookingData(data: BulkBookingEntities) {
    this.bulkBookingList = data;
  }

  @Mutation
  private setClientBookingData(data: ClientBookingEntities) {
    this.clientBookingList = data;
  }

  @Mutation
  public setResiListData(data: PrintDataEntitas[]) {
    this.resiListData = data;
  }

  @Mutation
  public setConfirm(value: boolean) {
    this.isConfirm = value;
  }

  @Mutation
  public setIsLoading(value: boolean) {
    this.isLoading = value;
  }

  @Mutation
  public setIsOpenUploadBulkBooking(value: boolean) {
    this.IsOpenUploadBulkBooking = value;
  }

  @Mutation
  public setIsOpenReUploadBulkBooking(value: boolean) {
    this.IsOpenReUploadBulkBooking = value;
  }

  @Mutation
  public setDetailClientBooking(val: ClientBookingTemplateDetail) {
    this.detailClientBookingData = val;
  }

  @Mutation
  public setOpenModalSuccess(val: boolean) {
    this.openModalSuccess = val;
  }

  @Mutation
  public setClientName(val: string) {
    this.clientName = val;
  }

  @Mutation
  public setError(value: boolean) {
    this.isError = value;
  }

  @Mutation
  public setErrorCause(value: string) {
    this.errorCause = value;
  }

  @Mutation
  public setStatusClearFile(val: boolean) {
    this.isClearFile = val;
  }

  @Mutation
  public setFirstRequest(value: boolean) {
    this.isFirstRequest = value;
  }

  @Mutation
  public setFormAddBulkBooking(data: BulkBookingAddForm) {
    this.form = data;
  }

  @Mutation
  public setFormatTemplate(val: string) {
    this.form.formatTemplate = val;
  }

  @Mutation
  public setModalSuccess(status: boolean) {
    this.isModalSuccess = status;
  }

  @Mutation
  public setDetailRepairBulkBooking(val: DetailRepairBulkBooking) {
    this.detailRepairBulkBookingData = val;
  }

  @Mutation
  public setIsErrorRepair(response: any) {
    // Define field mappings from response to isErrorRepair
    const fieldMappings = {
      shipperPhoneNumber: ["senderPhone", "senderPhoneCaption"],
      shipperAddress: ['senderAddress', 'senderAddressCaption'],
      shipperName: ['senderName', 'senderNameCaption'],
      consigneePhone: ['receiverPhone', 'receiverPhoneCaption'],
      consigneeAddress: ['receiverAddress', 'receiverAddressCaption'],
      consigneeName: ['receiverName', 'receiverNameCaption'],
      consigneesAddressType: ['receiverAddressType', 'receiverAddressTypeCaption'],
      destinationDistrictName: ['destinationDistrictName', 'destinationDistrictNameCaption'],
      destinationPostalCode: ['destinationPostalCode', 'destinationPostalCodeCaption'],
      commodityCode: ['commodityCode', 'commodityCodeCaption'],
      codAmount: ['codAmount', 'codAmountCaption'],
      externalNumber: ['externalNumber', 'externalNumberCaption'],
      insuranceFlag: ['insuranceFlag', 'insuranceFlagCaption'],
      manualSttNumber: ['manualSttNumber', 'manualSttNumberCaption'],
      originDistrictName: ['originDistrictName', 'originDistrictNameCaption'],
      productType: ['productType', 'productTypeCaption'],
      serviceType: ['serviceType', 'serviceTypeCaption'],
      shipmentId: ['shipmentId', 'shipmentIdCaption'],
      totalPieces: ["totalPieces", "totalPiecesCaption"],
      totalWeight: ['totalWeight', 'totalWeightCaption'],
      valueOfGoods: ['valueOfGoods', 'valueOfGoodsCaption']
    };

    // Create result object
    const result: any = {};

    // Process each field mapping
    Object.entries(fieldMappings).forEach(
      ([responseKey, [errorKey, captionKey]]) => {
        // Set boolean flag based on existence of field in response
        result[errorKey] = !!response[responseKey];

        // Set caption value with optional chaining and fallback to empty string
        result[captionKey] = response[responseKey]?.[0]?.id || "";
      }
    );

    // Update isErrorRepair with the result
    Object.assign(this.isErrorRepair, result);
  }

  @Action
  public async setFirstPage() {
    this.bulkBookingList.pagination.page = 1;
  }

  @Action
  public async checkCPShipment(shipmentId: string) {
    const presenter = container.resolve(TrackingPresenter);

    return new Promise((resolve, reject) => {
      if (!shipmentId) {
        resolve();
        return;
      }
      if (!shipmentId.startsWith("CP")) {
        reject("Shipment ID tidak valid");
        return;
      }
      presenter.getTrackingStt(shipmentId, true)
        .then((res) => {
          resolve(res)
        }).catch(() => {
          reject("Shipment ID tidak valid")
        });
    })
  }
}

export const BulkBookingController = getModule(BulkBookingStore);
